import React from "react";
import {
    Box,
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Paper,
    IconButton,
    Tooltip,
    Chip,
} from "@mui/material";
import { Download, DownloadOutlined, InsertDriveFileOutlined } from "@mui/icons-material";
import { file } from "jszip";
import { downloadFile } from "apis/controllers/files";
import { safeDateFormat } from "qubCommon/helperMethods/dateHelper";

const download = async (file) => {
    console.log(file)
    const res = await downloadFile(
        { Id: file?.id },
        { responseType: "blob" }
    );
    console.log(res)
    const url = URL.createObjectURL(new Blob([res]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${file.origFName}`);
    document.body.appendChild(link);
    link.click();
}

const UploadedFilesTable = ({ uploadedFiles = [], onDownload }) => {
    return (

        <TableContainer
            component={Paper}
            sx={{
                borderRadius: 2,
            }}
        >
            <Table stickyHeader>
                <TableHead>
                    <TableRow sx={{ bgcolor: "grey.100" }}>
                        <TableCell width="5%">#</TableCell>
                        <TableCell width="30%"><b>Όνομα Αρχείου</b></TableCell>
                        <TableCell width="10%" align="center"><b>Πλήθος</b></TableCell>
                        <TableCell width='20%'><b>Ώρα</b></TableCell>
                        <TableCell width="15%" align="center"><b>Τύπος</b></TableCell>
                        <TableCell width="10%" align="center"><b><Download /></b></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {uploadedFiles.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={6} align="center">
                                <Typography color="text.secondary" sx={{ py: 2 }}>
                                    Δεν υπάρχουν διαθέσιμα αρχεία
                                </Typography>
                            </TableCell>
                        </TableRow>
                    ) : (
                        uploadedFiles.map((file, index) => (
                            <TableRow
                                key={file.id}
                                hover
                                sx={{
                                    "&:hover": { bgcolor: "grey.50" },
                                    cursor: "default",
                                }}
                            >
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <InsertDriveFileOutlined
                                            sx={{ color: "primary.main", fontSize: 20 }}
                                        />
                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                            {file.origFName}
                                        </Typography>
                                    </Box>
                                </TableCell>
                                <TableCell>

                                    <Typography variant="body2" align='center' sx={{ fontWeight: 500 }}>
                                        {file?.number}
                                    </Typography>
                                </TableCell>
                                <TableCell>

                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                        {safeDateFormat(file.createdAt, 'dd/MM/yyyy HH:mm')}
                                    </Typography>
                                </TableCell>

                                <TableCell align="center">
                                    <Chip
                                        label={file.fileType || "Άγνωστο"}
                                        color="info"
                                        variant="outlined"
                                        size="small"
                                    />
                                </TableCell>
                                <TableCell align="center">
                                    <Tooltip title="Λήψη αρχείου">
                                        <IconButton
                                            onClick={() => download(file)}
                                            color="primary"
                                        >
                                            <DownloadOutlined />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>

    );
};

export default UploadedFilesTable;
